import { DateTime } from 'luxon';

export default (dateFrom: undefined | number, dateTo: undefined | number): boolean => {
  if (dateFrom === undefined || dateTo === undefined) {
    return false;
  }

  const dateFromTime = DateTime.fromMillis(dateFrom).startOf('day');
  const dateToTime = DateTime.fromMillis(dateTo).startOf('day');

  if (!dateFromTime.isValid || !dateToTime.isValid) {
    return false;
  }

  return dateFromTime.toMillis() === dateToTime.toMillis();
};
